import styled from "styled-components";

function ThemeListRo() {

    const ragnarokBGMList = [
  // Faixas 01-107 (Dados das imagens anteriores)
  { number: "01", title: "Title", total_time: "00:01:14" },
  { number: "02", title: "Gambler of highway", total_time: "00:03:03" },
  { number: "03", title: "Peaceful Forest", total_time: "00:02:30" },
  { number: "04", title: "I miss you", total_time: "00:02:46" },
  { number: "05", title: "Tread on the ground", total_time: "00:01:54" },
  { number: "06", title: "Risk your life", total_time: "00:02:49" },
  { number: "07", title: "Wind of Tragedy", total_time: "00:01:44" },
  { number: "08", title: "Theme of Prontera", total_time: "00:04:33" },
  { number: "09", title: "Great honor", total_time: "00:01:19" },
  { number: "10", title: "Divine Grace", total_time: "00:01:36" },
  { number: "11", title: "Theme of Morroc", total_time: "00:02:08" },
  { number: "12", title: "Streamside", total_time: "00:02:27" },
  { number: "13", title: "Theme of Geffen", total_time: "00:03:00" },
  { number: "14", title: "Theme of Payon", total_time: "00:02:22" },
  { number: "15", title: "Theme of Alberta", total_time: "00:03:20" },
  { number: "16", title: "Labyrinth", total_time: "00:02:18" },
  { number: "17", title: "Tresure Hunter", total_time: "00:02:36" },
  { number: "18", title: "Time up!!", total_time: "00:03:44" },
  { number: "19", title: "Under the ground", total_time: "00:03:22" },
  { number: "20", title: "Ancient groover", total_time: "00:02:04" },
  { number: "21", title: "Through the tower", total_time: "00:01:41" },
  { number: "22", title: "Backattack!!", total_time: "00:02:06" },
  { number: "23", title: "Travel", total_time: "00:03:23" },
  { number: "24", title: "Desert", total_time: "00:03:40" },
  { number: "25", title: "Plateau", total_time: "00:02:36" },
  { number: "26", title: "Everlasting Wanderers", total_time: "00:02:09" },
  { number: "27", title: "Dreamer's Dream", total_time: "00:03:20" },
  { number: "28", title: "You're in ruins", total_time: "00:02:26" },
  { number: "29", title: "Be nice 'n Easy", total_time: "00:02:26" },
  { number: "30", title: "One Step Closer", total_time: "00:02:59" },
  { number: "31", title: "Brassy Road", total_time: "00:02:48" },
  { number: "33", title: "Yuna Song", total_time: "00:02:23" },
  { number: "34", title: "Pampas Upas", total_time: "00:02:35" },
  { number: "35", title: "TeMPoison", total_time: "00:03:08" },
  { number: "36", title: "Nano East", total_time: "00:01:55" },
  { number: "37", title: "TeMPorsche", total_time: "00:02:23" },
  { number: "38", title: "Hamatan", total_time: "00:02:25" },
  { number: "39", title: "Theme of Al de Baran", total_time: "00:03:45" },
  { number: "40", title: "Fear...", total_time: "00:02:30" },
  { number: "41", title: "Rag All Night Long", total_time: "00:02:35" },
  { number: "42", title: "Curse'n Pain", total_time: "00:03:03" },
  { number: "43", title: "Morning Gloomy", total_time: "00:02:20" },
  { number: "44", title: "TeMP it Up", total_time: "00:02:10" },
  { number: "45", title: "Don't Piss me Off", total_time: "00:02:22" },
  { number: "46", title: "An Ant-lion's Pit", total_time: "00:02:11" },
  { number: "47", title: "Welcome Mr. Hwang", total_time: "00:02:20" },
  { number: "48", title: "Help Yourself", total_time: "00:02:38" },
  { number: "49", title: "Watery Grave", total_time: "00:02:30" },
  { number: "50", title: "Out of Curiosity", total_time: "00:02:18" },
  { number: "51", title: "Believe in myself", total_time: "00:02:12" },
  { number: "52", title: "Ready~", total_time: "00:01:43" },
  { number: "53", title: "White Christmas", total_time: "00:02:09" },
  { number: "54", title: "Come on my deer!!", total_time: "00:02:09" },
  { number: "55", title: "Welcome, my lord", total_time: "00:02:00" },
  { number: "56", title: "Silver Bell", total_time: "00:02:01" },
  { number: "57", title: "Don't cry, baby", total_time: "00:02:04" },
  { number: "58", title: "Jingle Bell on Ragnarok", total_time: "00:02:06" },
  { number: "59", title: "Theme of Lutie / Snow In My...", total_time: "00:03:48" },
  { number: "60", title: "Aeon", total_time: "00:01:57" },
  { number: "61", title: "Zingaro", total_time: "00:02:18" },
  { number: "62", title: "High Roller Coaster", total_time: "00:02:25" },
  { number: "63", title: "Mucho Gusto", total_time: "00:02:52" },
  { number: "64", title: "One Fine Day", total_time: "00:02:27" },
  { number: "65", title: "Into the Abyss", total_time: "00:02:59" },
  { number: "66", title: "Wanna Be Free!!", total_time: "00:02:45" },
  { number: "67", title: "TeMPotato", total_time: "00:02:18" },
  { number: "68", title: "Jazzy Funky Sweety", total_time: "00:01:53" },
  { number: "69", title: "Retro Metro", total_time: "00:02:44" },
  { number: "70", title: "Theme of Juno", total_time: "00:02:16" },
  { number: "71", title: "Antique Cowboy", total_time: "00:02:04" },
  { number: "72", title: "Big Guys Love This", total_time: "00:02:19" },
  { number: "73", title: "Higher than the sun", total_time: "00:02:03" },
  { number: "74", title: "Not so far away", total_time: "00:02:13" },
  { number: "75", title: "Come, and Get It!", total_time: "00:02:37" },
  { number: "76", title: "Purity of your smile", total_time: "00:02:26" },
  { number: "77", title: "Can't go home again, baby", total_time: "00:02:26" },
  { number: "78", title: "adios", total_time: "00:02:07" },
  { number: "79", title: "The Great", total_time: "00:02:28" },
  { number: "80", title: "Jumping Dragon", total_time: "00:02:00" },
  { number: "81", title: "Thai Orchid", total_time: "00:02:41" },
  { number: "82", title: "Muay Thai King", total_time: "00:02:16" },
  { number: "83", title: "Sleepless", total_time: "00:02:07" },
  { number: "84", title: "Christmas in the 13th Month", total_time: "00:03:04" },
  { number: "85", title: "Dancing Christmas in the 13th...", total_time: "00:03:16" },
  { number: "86", title: "Steel Me", total_time: "00:03:22" },
  { number: "87", title: "Ethnica", total_time: "00:03:02" },
  { number: "88", title: "Come in Peace", total_time: "00:03:19" },
  { number: "89", title: "We have Lee but you don't h...", total_time: "00:02:32" },
  { number: "90", title: "Noblesse Oblige", total_time: "00:02:30" },
  { number: "91", title: "CheongChoon", total_time: "00:02:49" },
  { number: "92", title: "Naive Rave", total_time: "00:02:30" },
  { number: "93", title: "Latinnnova", total_time: "00:02:13" },
  { number: "94", title: "Theme of Rael", total_time: "00:02:20" },
  { number: "95", title: "Underneath The Temple", total_time: "00:01:48" },
  { number: "96", title: "Yetit Petit", total_time: "00:02:34" },
  { number: "97", title: "Lastman Dancing", total_time: "00:02:16" },
  { number: "98", title: "Top Hoppy", total_time: "00:01:45" },
  { number: "99", title: "Uncanny Lake", total_time: "00:02:01" },
  { number: "100", title: "Abyss", total_time: "00:02:32" },
  { number: "101", title: "AbSolitude", total_time: "00:02:07" },
  { number: "102", title: "Erebos' Prelude", total_time: "00:03:07" },
  { number: "103", title: "Invisible Invasion", total_time: "00:02:44" },
  { number: "104", title: "On Your Way Back", total_time: "00:02:34" },
  { number: "105", title: "Rose of Sharon", total_time: "00:02:12" },
  { number: "106", title: "Sleeping Volcano", total_time: "00:02:28" },
  { number: "107", title: "Seven Days Seven Nights", total_time: "00:02:32" },
  
  // Faixas 108-137 (Dados de image_cf5d72.png)
  { number: "108", title: "Angelica", total_time: "00:02:53" },
  { number: "109", title: "Alpen Rose", total_time: "00:02:38" },
  { number: "110", title: "Kingdom Memories", total_time: "00:03:48" },
  { number: "111", title: "Good Morning", total_time: "00:04:10" },
  { number: "112", title: "Good Night", total_time: "00:03:09" },
  { number: "113", title: "Monastery In Disguise", total_time: "00:04:13" },
  { number: "114", title: "Theme of Moscovia", total_time: "00:02:01" },
  { number: "115", title: "Tale of the East", total_time: "00:02:20" },
  { number: "116", title: "Away from Home", total_time: "00:02:02" },
  { number: "117", title: "Dream of a Whale", total_time: "00:02:11" },
  { number: "118", title: "Taiko's Fury", total_time: "00:02:31" },
  { number: "119", title: "Stained Memories", total_time: "00:02:32" },
  { number: "120", title: "Fissure Eruption", total_time: "00:02:36" },
  { number: "121", title: "Outer Breath", total_time: "00:05:46" },
  { number: "122", title: "Ethical Aspiration", total_time: "00:03:12" },
  { number: "123", title: "Into The Arena!", total_time: "00:02:49" },
  { number: "124", title: "Stranger Aeons", total_time: "00:02:56" },
  { number: "125", title: "Forbidden Anguish", total_time: "00:03:14" },
  { number: "126", title: "New World Orde", total_time: "00:02:27" },
  { number: "127", title: "Mystic Haze", total_time: "00:02:09" },
  { number: "128", title: "Splendide Dreams", total_time: "00:02:34" },
  { number: "129", title: "Fireflies Heaven", total_time: "00:02:11" },
  { number: "130", title: "Dread and Bold", total_time: "00:02:31" },
  { number: "131", title: "Daytime in Manuk", total_time: "00:02:39" },
  { number: "132", title: "March with Irish Whistle", total_time: "00:02:34" },
  { number: "133", title: "Sunny Side of Life", total_time: "00:03:07" },
  { number: "134", title: "Borborema", total_time: "00:03:12" },
  { number: "135", title: "At Dusk", total_time: "00:04:16" },
  { number: "136", title: "Emotion Creep", total_time: "00:04:04" },
  { number: "137", title: "Dazzling Snow", total_time: "00:02:16" },

  // Faixas 138-172 (Dados de image_cf5d12.png)
  { number: "138", title: "TeMPlatonic", total_time: "00:02:32" },
  { number: "139", title: "Sugar Cane Carnival", total_time: "00:03:05" },
  { number: "140", title: "Twilight Heaven", total_time: "00:03:01" },
  { number: "141", title: "Tricky Cheeky", total_time: "00:02:39" },
  { number: "142", title: "Arrival", total_time: "00:02:35" },
  { number: "143", title: "Mother Earth", total_time: "00:02:43" },
  { number: "144", title: "Silent Voyage", total_time: "00:02:44" },
  { number: "145", title: "Marshmallow Waltz", total_time: "00:02:02" },
  { number: "146", title: "Diamond Dust", total_time: "00:02:08" },
  { number: "147", title: "Octopus Scramble", total_time: "00:02:03" },
  { number: "148", title: "Melt Down!", total_time: "00:02:07" },
  { number: "149", title: "Theme of Port Malaya", total_time: "00:02:04" },
  { number: "150", title: "Uncanny Dreams", total_time: "00:02:24" },
  { number: "151", title: "Maximum", total_time: "00:02:24" },
  { number: "152", title: "Voices", total_time: "00:01:41" },
  { number: "153", title: "Horizon", total_time: "00:02:21" },
  { number: "154", title: "Eclage", total_time: "00:02:47" },
  { number: "155", title: "Eclage", total_time: "00:02:23" },
  { number: "156", title: "Beyond The Grave", total_time: "00:02:24" },
  { number: "157", title: "Disillusion", total_time: "00:02:01" },
  { number: "158", title: "Indelible Scars", total_time: "00:02:11" },
  { number: "159", title: "Judgement", total_time: "00:02:02" },
  { number: "160", title: "Jittering Nightmare", total_time: "00:02:24" },
  { number: "161", title: "Forest of Despiar", total_time: "00:02:32" },
  { number: "162", title: "Dark Light", total_time: "00:03:14" },
  { number: "163", title: "Lost souls", total_time: "00:02:38" },
  { number: "164", title: "From the Grave", total_time: "00:02:17" },
  { number: "165", title: "Apex Fortress", total_time: "00:03:49" },
  { number: "166", title: "Brutal Ritual", total_time: "00:02:50" },
  { number: "167", title: "Shade of a Shadow", total_time: "00:02:34" },
  { number: "168", title: "How to recue our dragon", total_time: "00:02:59" },
  { number: "169", title: "Little kitty's adventure", total_time: "00:01:31" },
  { number: "170", title: "Welcome to Doram town", total_time: "00:01:38" },
  { number: "171", title: "Django vs Yojimbo", total_time: "00:02:15" },
  { number: "172", title: "Macaroni Express", total_time: "00:02:17" },
  { number: "174", title: "Ethnically Diverse", total_time: "00:02:00" },
  { number: "175", title: "Cat on Bullet", total_time: "00:01:54" },
  { number: "176", title: "Tears of Deviant", total_time: "00:02:07" },
  { number: "177", title: "mysterious mansion", total_time: "00:01:35" },
  { number: "178", title: "behind the silence", total_time: "00:02:20" },
  { number: "179", title: "Echoes of Nature", total_time: "00:02:05" },
  { number: "180", title: "Finding pillow book", total_time: "00:01:32" },
  { number: "181", title: "limits of darkness", total_time: "00:01:26" },
  { number: "182", title: "Cake Is Lie", total_time: "00:04:32" },
  { number: "183", title: "I Need You", total_time: "00:03:44" },
  { number: "184", title: "Magdaros", total_time: "00:03:16" },
  { number: "185", title: "Once upon a December", total_time: "00:03:06" },
  { number: "186", title: "Theme of Wolf", total_time: "00:03:04" },
  { number: "187", title: "Words from the Myths", total_time: "00:03:20" },
  { number: "188", title: "At last I heard", total_time: "00:03:29" },
  { number: "189", title: "My Precious Baby", total_time: "00:03:17" },
  { number: "190", title: "Define Grace", total_time: "00:02:41" },
  { number: "191", title: "Remember Blueblue", total_time: "00:07:02" },
  { number: "192", title: "Great Enemy Felled", total_time: "00:02:55" },
  { number: "193", title: "Icewind", total_time: "00:03:35" },
  { number: "194", title: "Non Lay La", total_time: "00:03:20" },
  { number: "195", title: "Hydra", total_time: "00:02:40" },
  { number: "196", title: "Theme of Enki", total_time: "00:03:07" },
  { number: "197", title: "Call of Cathulhu", total_time: "00:02:54" },
  { number: "198", title: "Theme of Luna Forma", total_time: "00:03:20" },
  { number: "199", title: "Fishman's Horizon", total_time: "00:03:04" },
  { number: "200", title: "Mrglglgl'gul", total_time: "00:03:01" },
  { number: "201", title: "Mana Light", total_time: "00:03:07" },
  { number: "202", title: "Chrono Tango", total_time: "00:02:58" },
  { number: "203", title: "Valhalla calling me", total_time: "00:02:40" },
  { number: "204", title: "Reiðr dýr i Yggdrasill", total_time: "00:03:40" },
  { number: "205", title: "Root and root and another root", total_time: "00:03:13" },
  { number: "206", title: "Nafn er eigі munat", total_time: "00:04:52" },
  { number: "207", title: "Theme of Muspelheim", total_time: "00:02:52" },
  { number: "208", title: "Shadow over Gravity", total_time: "00:04:45" },
  { number: "209", title: "Eyes of Geffenia", total_time: "00:02:33" },
  { number: "997", title: "Silence", total_time: "00:00:59" }
];
    return(ragnarokBGMList)
}

export {ThemeListRo};